import { render, staticRenderFns } from "./LensTagsIcon.vue?vue&type=template&id=99f82c14&scoped=true"
import script from "./LensTagsIcon.vue?vue&type=script&lang=js"
export * from "./LensTagsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f82c14",
  null
  
)

export default component.exports